import React from "react";
import { Outlet } from "react-router-dom";
import './leaves.scss';

const LeavesOutlet = () => {
    return (
        <div className="leaves">
            <Outlet />
        </div>
    )
}

export default LeavesOutlet;